import React, { useEffect, useState } from 'react';
import api from '../../axios/axios';
import Sorting from './Sorting'; // Import the Sorting Component
import Filtering from './Filtering'; // Import the Filtering Component
import ProductDisplay from './ProductDisplay'; // Import the Product Display Component
import { useDispatch, useSelector } from 'react-redux';
import ProductTypes from './ProductTypes';
// import Spinner from '../../utils/Spinner';
import Swal from 'sweetalert2';
import { setLoading, setPriceFilteredProducts } from '../../redux/product/productSlice';
import { useLocation } from 'react-router-dom';

const FilteredProducts = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.product.loading);
  const [selectedPrice, setSelectedPrice] = useState('All');
  const location = useLocation();

  // Get productType from query param
  const params = new URLSearchParams(location.search);
  const productTypeParam = params.get('productType');

  useEffect(() => {
    if (productTypeParam && productTypeParam !== 'All') {
      fetchProductTypeProducts(productTypeParam);
    } else {
      fetchAllProducts();
    }
  }, [dispatch, productTypeParam]);

  // Fetch all products when the page initially loads
  const fetchAllProducts = async () => {
    try {
      dispatch(setLoading(true));
      const response = await api.get('user/getAllProducts'); 
      
      if (response.data && Array.isArray(response.data.products)) {
        dispatch(setPriceFilteredProducts({
          priceFilteredProducts: response.data.products, 
          productsTypeNames: response.data.productTypes, 
        }));
      } else {
        console.error('Unexpected API response format:', response);
      }
  
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      Swal.fire("Something went wrong");
      console.error(error);
    }
  };
  
  
  // Fetch filtered products based on price range
  const fetchProductsBasedFilter = async (selectedPrice) => {
    try {
      const response = await api.get('user/getFilteredproducts', {
        params: { selectedPrice },
      });
      dispatch(setPriceFilteredProducts({
        priceFilteredProducts: response.data, 
      }));
    } catch (error) {
      Swal.fire("Something went wrong")
    }
  };
  
  // Fetch products by product type (copied from ProductTypes.jsx)
  const fetchProductTypeProducts = async (productType) => {
    try {
      const response = await api.get('user/productTypesProducts', {
        params: { productType },
      });
      dispatch(setPriceFilteredProducts({
        priceFilteredProducts: response.data
      }));
    } catch (error) {
      Swal.fire({ 
        title: 'Error',
        text: error.response?.data?.message || "There was an error fetching the products",
        icon: 'error',
        confirmButtonText: 'Try Again'
      });
    }
  };

  return (
    <div className="max-w-6xl mx-auto p-6">
      {/* Sorting Component */}
      <div className='md:flex grid grid-cols-2 gap-x-10 md:gap-6'>
        <Sorting />
        {/* Filtering Component */}
        <Filtering selectedPrice={selectedPrice} onPriceChange={setSelectedPrice} />
        <ProductTypes />
      </div>
      {/* Product Display Component */}
      <ProductDisplay loading={loading} />
    </div>
  );
};

export default FilteredProducts;